import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { loginUser } from "../auth/authLoginSlice";
import { toast } from "react-toastify";
import parse from "html-react-parser";

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  username: null,
  CREATED_BY_USER_ID: 4,
  successfullyRegistered: false,
  emailFound: false,
};

// our slice
const quickRegisterSlice = createSlice({
  name: "quickRegister",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setGeneratedUsername: (state, { payload }) => {
      state.loading = false;
      state.username = payload;
      state.success = true;
      state.error = false;
    },
    setSuccessfullyRegistered: (state) => {
      state.successfullyRegistered = true;
    },
    setEmailFound: (state, { payload }) => {
      state.emailFound = payload;
    },
  },
});
// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setGeneratedUsername,
  setQuickRegisterSuccess,
  setSuccessfullyRegistered,
  setEmailFound,
} = quickRegisterSlice.actions;

export const quickRegisterSelector = (state) => state.quickRegister;

// export the default reducer
export default quickRegisterSlice.reducer;

// GenerateUsername
export const GenerateUsername = (firstname, lastname) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const reqData = { firstName: firstname, lastName: lastname };

    let { data: response } = await http.post("User/GenerateUserName", reqData);
    if (response.responseCode == 0) {
      dispatch(setGeneratedUsername(response.responseObject.userName));
      dispatch(setSuccess());
    } else {
      if (response.responseCode == -2) {
        dispatch(setError("-2"));
      } else {
        dispatch(setError(response.responseDescription));
      }
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

const capitalizeFirstLetter = (str) =>
  str.replace(/^\s*./, (match) => match.toUpperCase());

const getOktaErrorMessage = (oktaError) => {
  try {
    const outer = JSON.parse(oktaError);
    const inner = JSON.parse(outer.error.message);
    const message =
      inner.errorCauses?.[0]?.errorSummary ||
      inner.errorSummary ||
      outer.error.message ||
      "Something went wrong";
    return capitalizeFirstLetter(message);
  } catch {
    return "Something went wrong";
  }
};

// QuickRegistration
export const QuickRegistration =
  (quickRegisterFormData, currentLanguage, navigate) => async (dispatch) => {
    try {
      dispatch(setLoading());
      var reqData = {
        PreferredLanguage: quickRegisterFormData.language_type,
        FirmName: quickRegisterFormData.firmname,
        FirstName: quickRegisterFormData.firstname,
        MiddleName: quickRegisterFormData.middlename,
        LastName: quickRegisterFormData.lastname,
        PhoneNumber: quickRegisterFormData.phonenumber,
        Extension: quickRegisterFormData.ext,
        Email: quickRegisterFormData.email,
        Address1: quickRegisterFormData.Address1 || "",
        Address2: quickRegisterFormData.Address2 || "",
        City: quickRegisterFormData.City,
        Country: quickRegisterFormData.Country,
        PostalCode: quickRegisterFormData.PostalCode,
        Province: quickRegisterFormData.Province,
        UserName: quickRegisterFormData.email,
        Password: quickRegisterFormData.password,
        Note: "Profile created via quick registration.",
        Fax: quickRegisterFormData.faxnumber || "",
        EntitledToPractice: true,
        IsActive: true,
        CreatedBy: initialState.CREATED_BY_USER_ID,
      };
      // Make API call for quick registration
      const { data: response } = await http.post("User/QuickRegister", reqData);
      if (
        !response.responseObject.enMessage &&
        !response.responseObject.oktaError
      ) {
        dispatch(setSuccessfullyRegistered());
        dispatch(setSuccess());
        // dispatch(
        //   setEmailFound(response.responseObject.enMessage ? true : false),
        // );
        // navigate("/");
        // toast.success(
        //   <>
        //     <strong>Registration successful!</strong>
        //     <br></br>Please login to continue
        //   </>,
        //   {
        //     position: "top-center",
        //     autoClose: 7000,
        //     closeOnClick: true,
        //     draggable: true,
        //     style: {
        //       whiteSpace: "pre-wrap",
        //       wordBreak: "break-word",
        //       maxWidth: "500px",
        //       textAlign: "center",
        //     },
        //   }
        // );
      } else {
        if (response.responseObject.enMessage) {
          // dispatch(setError("-2"));
          // } else {
          dispatch(setError(response.responseObject.enMessage));
          toast.error(
            currentLanguage == "en"
              ? response.responseObject.enMessage
              : response.responseObject.frMessage,
            {
              position: "top-center",
              autoClose: 7000,
              closeOnClick: true,
              draggable: true,
              style: {
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxWidth: "500px",
                textAlign: "center",
              },
            },
          );
        } else if (
          response.responseObject.isShowOktaErrorMessage &&
          response.responseObject.oktaError
        ) {
          dispatch(
            setError(getOktaErrorMessage(response.responseObject.oktaError)),
          );
          toast.error(
            getOktaErrorMessage(response.responseObject.oktaError) ||
              "Failed Request",
            {
              position: "top-center",
              autoClose: 7000,
              closeOnClick: true,
              draggable: true,
              style: {
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxWidth: "500px",
                textAlign: "center",
              },
            },
          );
        }
      }
    } catch (error) {
      const errorMessage =
        error.response &&
        error.response.data &&
        error.response.data.responseObject
          ? error.response.data.responseObject?.isShowOktaErrorMessage &&
            error.response.data.responseObject?.oktaError
            ? getOktaErrorMessage(error.response.data.responseObject?.oktaError)
            : currentLanguage == "en"
              ? error.response.data.responseObject?.enMessage
              : error.response.data.responseObject?.frMessage
          : "Failed Request";

      dispatch(setError(errorMessage));
      dispatch(
        setEmailFound(
          error.response.data.responseObject?.enMessage ? true : false,
        ),
      );

      toast.error(<div>{parse(errorMessage)}</div> || "Failed Request", {
        position: "top-center",
        autoClose: 7000,
        closeOnClick: true,
        draggable: true,
        style: {
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          maxWidth: "600px",
          textAlign: "center",
        },
      });
    }
  };
